/**
 * Calculates the number of line items in a sale
 * @param sale - The sale object
 * @returns The number of items in the sale
 */
export function getSaleLineCount(sale: Sale | null | undefined): number {
  if (!sale?.SaleLines?.SaleLine) {
    return 0;
  }

  if (Array.isArray(sale.SaleLines.SaleLine)) {
    return sale.SaleLines.SaleLine.length;
  }

  return 1;
}
